import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrownextNopadding = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 15, "data-name": "icon/arrownext/nopadding", viewBox: "0 0 10 15", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m12.44 19.091-.908-.908 6.5-6.5-6.5-6.5.908-.908 6.951 6.951.434.454-.434.454z", "data-name": "Path 1660", transform: "translate(-10.951 -4.281)", fill: "#cbd4dd" }));
const ForwardRef = forwardRef(SvgIconArrownextNopadding);
export { ForwardRef as ReactComponent };
